import { createColumnHelper } from '@tanstack/react-table';

import { Access } from '../types';

export const helper = createColumnHelper<Access>();
